import { Vector3 } from 'three'

export default function getTextPositions(text, fontSize, canvasWidth, canvasHeight) {
    const canvas = document.createElement('canvas')
    canvas.width = canvasWidth
    canvas.height = canvasHeight
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = 'white'
    ctx.font = `${fontSize}px Arial`
    ctx.letterSpacing = '1px'
    ctx.textAlign = 'start'
    ctx.textBaseline = 'bottom'
    let lines = []
    let line = ''
    text = text.replace(/\n/g, ' ')
    const words = text.split(' ')

    for (let word of words) {
        const testLine = line + word + ' '
        const testWidth = ctx.measureText(testLine).width
        if (testWidth > canvasWidth && line !== '') {
            lines.push(line.trim())
            line = word + ' '
        } else {
            line = testLine
        }
    }
    lines.push(line.trim())

    lines.forEach((line, index) => {
        const y = (index + 1) * fontSize
        ctx.fillText(line, 0, y, canvasWidth)
    })

    const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight)
    const alphaPixelBuffer = imageData.data.filter((_, i) => i % 4 === 3)
    const positions = []


    for (let i = 0; i < lines.length; i++) {
        const lineWidth = ctx.measureText(lines[i]).width
        for (let x = 0; x < canvasWidth; x++) {
            for (let y = 0; y < fontSize; y++) {
                const index = (y + i * fontSize) * canvasWidth + x
                const alpha = alphaPixelBuffer[index]
                if (alpha > 0) {
                    const yCoord = (lines.length / 2 - i) * fontSize - y
                    positions.push(new Vector3(x - lineWidth / 2, yCoord, 0))
                }
            }
        }
    }
    return positions
}